const deployedURL = "https://jobark.up.railway.app";
const tunnelURL = "https://00svndck-3027.asse.devtunnels.ms";
const stagingURL = "https://staging.backend.jobark.co.uk";
const prodUrl = "https://production.backend.jobark.co.uk";

const config = {
  apiURL: `${import.meta.env.VITE_API_URL || prodUrl}/api/v1`,
  socketURL: `${import.meta.env.VITE_SOCKET_URL || prodUrl}`,
};

export default config;